module.exports = __webpack_public_path__ + "static/media/4.7b7ff03d.jpg";